import React from 'react';
import Home from '../Home';
import Patients from '../Patients';
import Appointments from '../Appointments';
import Treatments from '../Treatments';
import Prescriptions from '../Prescriptions';
import LabOrders from '../LabOrders';
import Inventory from '../Inventory';
import Payments from '../Payments';
import Users from '../Users';
import Settings from '../Settings';
import Profile from '../Profile';
import Clinics from '../Clinics';
import Announcements from '../Announcements';
import Subscriptions from '../Subscriptions';
import ClinicSubscriptions from '../ClinicSubscriptions';

const HomeIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>;
const PatientsIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const AppointmentsIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>;
const TreatmentsIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0L12 2.69z"></path></svg>;
const PrescriptionsIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>;
const LabIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg>;
const InventoryIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>;
const PaymentsIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>;
const UsersIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const SettingsIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>;

export const routeConfig = {
    home: {
        id: 'home',
        title: 'Ana Sayfa',
        component: Home,
        icon: <HomeIcon />,
        allowedRoles: ['admin', 'doctor', 'staff', 'patient', 'super_admin']
    },
    clinics: {
        id: 'clinics',
        title: 'Klinikler',
        component: Clinics,
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18"/><path d="M5 21V7l8-4 8 4v14"/><path d="M8 21v-4h8v4"/><path d="M12 11v4"/></svg>,
        allowedRoles: ['super_admin']
    },
    announcements: {
        id: 'announcements',
        title: 'Duyurular',
        component: Announcements,
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>,
        allowedRoles: ['super_admin']
    },
    subscriptions: {
        id: 'subscriptions',
        title: 'Abonelikler',
        component: Subscriptions,
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>,
        allowedRoles: ['super_admin']
    },
    'my-subscription': {
        id: 'my-subscription',
        title: 'Abonelik',
        component: ClinicSubscriptions,
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>,
        allowedRoles: ['admin'] // Klinik yöneticisi
    },
    patients: {
        id: 'patients',
        title: 'Hastalar',
        component: Patients,
        icon: <PatientsIcon />,
        allowedRoles: ['admin', 'doctor', 'staff']
    },
    appointments: {
        id: 'appointments',
        title: 'Randevular',
        component: Appointments,
        icon: <AppointmentsIcon />,
        allowedRoles: ['admin', 'doctor', 'staff', 'patient']
    },
    treatments: {
        id: 'treatments',
        title: 'Tedaviler',
        component: Treatments,
        icon: <TreatmentsIcon />,
        allowedRoles: ['admin', 'doctor']
    },
    prescriptions: {
        id: 'prescriptions',
        title: 'Reçeteler',
        component: Prescriptions,
        icon: <PrescriptionsIcon />,
        allowedRoles: ['admin', 'doctor']
    },
    'lab-orders': {
        id: 'lab-orders',
        title: 'Laboratuvar',
        component: LabOrders,
        icon: <LabIcon />,
        allowedRoles: ['admin', 'doctor']
    },
    inventory: {
        id: 'inventory',
        title: 'Stok Takibi',
        component: Inventory,
        icon: <InventoryIcon />,
        allowedRoles: ['admin', 'doctor']
    },
    payments: {
        id: 'payments',
        title: 'Ödemeler',
        component: Payments,
        icon: <PaymentsIcon />,
        allowedRoles: ['admin']
    },
    users: {
        id: 'users',
        title: 'Kullanıcılar',
        component: Users,
        icon: <UsersIcon />,
        allowedRoles: ['admin']
    },
    settings: {
        id: 'settings',
        title: 'Ayarlar',
        component: Settings,
        icon: <SettingsIcon />,
        allowedRoles: ['admin', 'super_admin']
    },
    profile: {
        id: 'profile',
        title: 'Profilim',
        component: Profile,
        icon: null, // Not in sidebar
        allowedRoles: ['admin', 'doctor', 'staff', 'patient', 'super_admin']
    }
};